import { CmsApiDonateBlockData } from 'modules/cms/api/types/blocks/CmsApiDonateBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsDonateBlock } from './CmsDonateBlock';

export const CmsDonateBlockMapping: CmsBlockMapping<CmsApiDonateBlockData> = {
  invariant: [],
  width: CmsMappedBlockWidth.FULL,
  Component: CmsDonateBlock,
  AmpComponent: CmsDonateBlock,
};
